import type { Messages } from "./types";

export const en: Messages = {
  // chat
  "chat.send": "Send",
  "chat.input_placeholder": "Type a message — Enter to send, Shift+Enter for newline",
  "chat.thinking": "Thinking",
  "chat.welcome_title": "Pick an agent to start chatting",
  "chat.welcome_desc": "Select or create an agent on the left",
  "chat.create_session": "Create a session first",
  "chat.session_exited": "Session suspended — send a message to resume",
  "chat.you": "You",
  "chat.loading": "Loading...",
  "chat.new_content": "New content",

  // tool
  "tool.pending": "pending",
  "tool.completed": "completed",
  "tool.approved": "approved",
  "tool.denied": "denied",
  "tool.approve": "Allow",
  "tool.deny": "Deny",
  "tool.done_count": "{done}/{total} done",
  "tool.section_title": "Tool calls",

  // approval
  "approval.title": "Pending approval",
  "approval.pending_count": "{n} pending approval(s)",

  // memory
  "memory.title": "Memory Confirmation",
  "memory.save": "Save Memory",
  "memory.delete": "Delete Memory",

  // todo
  "todo.title": "Task List",
  "todo.tag": "TODO {done}/{total}",
  "todo.tooltip": "Click to view task list",

  // model switch
  "model.switch_title": "Switch Model (this session only)",
  "model.adapter_type": "Adapter Type",
  "model.provider": "Provider",
  "model.model": "Model",
  "model.no_provider_hint": "Add a provider in Settings first",
  "model.loading_models": "Loading models...",
  "model.tooltip": "Click to switch model",

  // attachment
  "attachment.add": "Add file",
  "attachment.voice": "Voice input (coming soon)",

  // cost
  "cost.tpl": "💰{cost} | total: {totalCost} · ⏱{duration} · {pct}% ({usedTokens}/{ctxWindow})",

  // common
  "common.confirm": "Confirm",
  "common.cancel": "Cancel",

  // error
  "error.transport": "Connection error",
  "error.upload": "Attachment upload failed",
  "error.switch_model": "Failed to switch model",
  "error.history": "Failed to load history",
  "error.code_block_render": "Code block render failed (fell back to default)",
  "error.unknown": "Unknown error",
};
